









































































import { Component, Vue } from "vue-property-decorator";
import { IMTGSet } from "@/interface";
import { Lotto } from "@/lotto";

import LotteryItem from "@/components/LotteryItem.vue";

@Component({
    name: "LotteryView",
    components: {
        LotteryItem,
    },
})
export default class LotteryView extends Vue {

    public lotterySpin: string = "";

    private result: IMTGSet[] = [];

    public async startSpin() {
        const lottery = (await this.$root.$data.lottery) as Lotto;

        this.$root.$data.gathererLink = "";
        this.lotterySpin = Date.now().toString();

        this.result = lottery.generateResult(this.$root.$data.setsToGenerate);

        setTimeout(() => {
            this.$root.$data.gathererLink = this.generateGathererLink();
        }, this.$root.$data.lotteryTime * this.$root.$data.setsToGenerate + 1);
    }

    private generateGathererLink(): string {
        const link = new URL("https://scryfall.com/search");
        const setQuery = this.result.map((set) => `set:${set.code}`).join(" OR ");

        link.searchParams.append("unique", "cards");
        link.searchParams.append("as", "grid");
        link.searchParams.append("order", "name");

        link.searchParams.append("q", `(${setQuery})`);

        return link.toString();
    }
}
